export default __webpack_public_path__ + "static/media/btn_-chat_v.8a66b9ce.png";